import { stdCouleurBleu } from "@commonStyle"
import { Pressable } from "react-native"
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons"

type FichierIconProps = {
  file: string,
}
export default function FichierIcon({ file }: FichierIconProps){
  if(file) {
    return(
      <Pressable onPress={() => {}}>
        <MaterialCommunityIcons name="file-cloud" color={stdCouleurBleu} size={24} />
      </Pressable>
    )
  }
  return null;
}